import { reviewSessionService } from '../../services/reviewSession.service';
import { notificationActions } from './notification.actions';

const createFromDiary = (diaryId: number) => async (dispatch: any) => {
  try {
    const result = await reviewSessionService.createFromDiary(diaryId);
    if (result?.success) {
      dispatch(notificationActions.addNotification('✅ Tạo bài ôn tập thành công!', 'SUCCESS'));
    } else {
      dispatch(notificationActions.addNotification('❌ ' + (result?.message || 'Không thể tạo bài ôn tập'), 'DANGER'));
    }
    return result;
  } catch (error: any) {
    dispatch(notificationActions.addNotification('❌ Lỗi khi tạo bài ôn tập: ' + (error?.message || error), 'DANGER'));
    throw error;
  }
};

const rebuildFromDiary = (diaryId: number) => async (dispatch: any) => {
  try {
    const result = await reviewSessionService.rebuildFromDiary(diaryId);
    return result;
  } catch (error: any) {
    dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    throw error;
  }
};

const getAll = () => async (dispatch: any) => {
  try {
    const result = await reviewSessionService.getAll();
    return result;
  } catch (error: any) {
    dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    throw error;
  }
};

const deleteSession = (id: number) => async (dispatch: any) => {
  try {
    await reviewSessionService.deleteSession(id);
    dispatch(notificationActions.addNotification('Đã xoá bài ôn tập!', 'SUCCESS'));
  } catch (error: any) {
    dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    throw error;
  }
};

export const reviewSessionActions = {
  createFromDiary,
  rebuildFromDiary,
  getAll,
  deleteSession,
};
